import React from "react";
import Img from "gatsby-image";
import { getImages } from "utils/images";
import { graphql, useStaticQuery } from "gatsby";

export default function SpectroLogo() {
  const data = useStaticQuery(graphql`
    query {
      logo: file(relativePath: { eq: "logo.png" }) {
        base
        childImageSharp {
          fixed(width: 114, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
    }
  `);
  const images = getImages(data);

  return <Img {...images.getFile("logo")} />;
}
